import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { MaintenanceResponse } from '@shure/cloud/shared/maintenance/feature-maintenance';
import { OrganizationsStoreService } from '@shure/cloud/shared/services/organizations-store-service';
import { APP_ENVIRONMENT, AppEnvironment } from '@shure/cloud/shared/utils/config';

@Injectable({
	providedIn: 'root'
})
export class MaintenanceModeService {
	constructor(
		private readonly httpClient: HttpClient,
		private readonly orgStoreService: OrganizationsStoreService,
		@Inject(APP_ENVIRONMENT) private appEnv: AppEnvironment
	) {}

	public fetchMaintenacMode$(): Observable<MaintenanceResponse> {
		const resp: MaintenanceResponse = {
			maintenance: true,
			banner: true,
			startAt: '',
			endAt: '',
			message: 'whats up'
		};

		const headers = new HttpHeaders({
			Accept: 'application/json'
		});
		this.httpClient.get(this.appEnv.cdmFeatureFlags?.maintenanceModeJsonPath ?? '', { headers }).subscribe({
			next: (result) => {
				console.error({ path: this.appEnv.cdmFeatureFlags?.maintenanceModeJsonPath, maintenace: result });
			},
			error: (error) => {
				console.error({ path: this.appEnv.cdmFeatureFlags?.maintenanceModeJsonPath, maintenace: error });
			}
		});

		return of(resp);
	}
}
